import { getToken } from "js/formatting/getToken";
import config from "../../config/config";

export async function sendPaymetToOrbitalApi(
  amount,
  orderID,
  useCustomerRefNum,
  blockCode
) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      orbitRequest: {
        version: "4.3",
        transType: "AC",
        merchant: {
          bin: "000001",
          terminalID: "001",
        },
        order: {
          orderID: orderID,
          comments: "comments",
          industryType: "EC",
          amount: amount,
        },
        paymentInstrument: {
          useProfile: {
            useCustomerRefNum: useCustomerRefNum,
          },
        },
        merchantInitiatedTransaction: {
          mitMsgType: "CGEN",
          mitStoredCredentialInd: "N",
          mitSubmittedTransactionID: "",
        },
      },
      blockCode: blockCode,
    }),
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/submit`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
